import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Paper,
  alpha,
} from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';

const NewsletterSubscribe = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('idle');

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus('loading');
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/subscribers`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      if (response.ok) {
        setStatus('success');
        setEmail('');
        setTimeout(() => setStatus('idle'), 3000);
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <Box sx={{ background: 'linear-gradient(135deg, #061527 0%, #0C2340 50%, #183B63 100%)', color: 'white', py: { xs: 6, md: 8 } }}>
      <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              bgcolor: alpha('#D4AF37', 0.15),
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 2,
            }}
          >
            <EmailOutlinedIcon sx={{ fontSize: 32, color: '#D4AF37' }} />
          </Box>
          <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
            Stay Updated
          </Typography>
          <Typography variant="body1" sx={{ color: alpha('#fff', 0.7), mb: 0 }}>
            Subscribe to our newsletter for exclusive deals and travel inspiration.
          </Typography>
        </Box>

        <Paper
          component="form"
          onSubmit={handleSubmit}
          elevation={0}
          sx={{
            display: 'flex',
            alignItems: 'center',
            bgcolor: alpha('#ffffff', 0.1),
            borderRadius: 3,
            p: 0.5,
            border: `1px solid ${alpha('#D4AF37', 0.3)}`,
            '&:focus-within': {
              borderColor: '#D4AF37',
            },
          }}
        >
          <TextField
            fullWidth
            placeholder="Enter your email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            variant="standard"
            type="email"
            required
            InputProps={{
              disableUnderline: true,
              sx: {
                color: 'white',
                px: 2,
                '&::placeholder': { color: alpha('#fff', 0.5), opacity: 1 },
                '& .MuiOutlinedInput-notchedOutline': { border: 'none' },
              },
            }}
            sx={{
              '& fieldset': { border: 'none' },
              '& .MuiInputBase-root': { '&:before': { display: 'none' }, '&:after': { display: 'none' } },
            }}
          />
          <Button
            type="submit"
            variant="contained"
            disabled={status === 'loading'}
            sx={{
              minWidth: 'auto',
              px: 3,
              py: 1.2,
              borderRadius: 2,
              bgcolor: '#0C2340',
              color: 'white',
              fontWeight: 700,
              '&:hover': { bgcolor: '#E2C56A' },
              '&:disabled': { bgcolor: alpha('#D4AF37', 0.4), color: alpha('#0C2340', 0.5) },
            }}
            endIcon={<SendIcon />}
          >
            {status === 'loading' ? 'Sending...' : 'Subscribe'}
          </Button>
        </Paper>

        {status === 'success' && (
          <Typography variant="body2" sx={{ mt: 2, color: '#34d399' }}>
            ✓ Successfully subscribed! Check your inbox.
          </Typography>
        )}
        {status === 'error' && (
          <Typography variant="body2" sx={{ mt: 2, color: '#ef4444' }}>
            Something went wrong. Please try again.
          </Typography>
        )}
      </Container>
    </Box>
  );
};

export default NewsletterSubscribe;